import { ExceptionEventComment } from "@fairfleet/geotab";
import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { RESULTS_LIMIT_EXCEPTION_EVENT_COMMENT } from "@/constants/resultsLimits";

/**
 * Hook to fetch ExceptionEvent comments based on exceptionEventSearch id.
 *
 * @param exceptionEventId - The ID of the ExceptionEvent to search for comments.
 * @returns - A list of ExceptionEventComment[].
 */
export function useExceptionEventCommentsByEventId(exceptionEventId?: string) {
  const { geotabClient, activeSessionId } = useGeotabClient();
  return useQuery({
    queryKey: ["exceptionEventComments", activeSessionId, exceptionEventId],

    queryFn: async ({ signal }) => {
      if (!exceptionEventId) {
        return Promise.resolve([]);
      }

      const response = await geotabClient.call(
        "Get",
        {
          typeName: "ExceptionEventComment",
          search: {
            exceptionEventSearch: {
              id: exceptionEventId,
            },
          },
          resultsLimit: RESULTS_LIMIT_EXCEPTION_EVENT_COMMENT,
        },
        signal,
      );

      return response as ExceptionEventComment[];
    },

    enabled: !!exceptionEventId
  });
}
